import { COLORS } from '@repo/design-system/index'
import { QIcon_chevron_left } from '@repo/icons/index'
import { ActivityComponentType } from '@stackflow/react'
import dynamic from 'next/dynamic'
import { APP_SCREEN_NAME } from '../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useIsWebview from '../../../modules/hooks/common/useIsWebview'
import useReturnFullUrl from '../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_ai_tutor } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import urls from '../../../modules/urls'
import { useConversationAIStack } from '../../../pages/[lang]/webview/conversational-ai'
import LoadingSpinner from '../../common/LoadingSpinner'
import WebviewStackContainer from '../common/WebviewStackContainer'

const ConversationListBody = dynamic(() => import('../../new-portal/conversational-ai/ConversationList'), {
  loading: () => (
    <div className="flex h-screen w-screen items-center justify-center">
      <LoadingSpinner lg show primary />
    </div>
  ),
})

const ConversationAIListTobNav = () => {
  const { useConversationAIFlow } = useConversationAIStack()
  const { push } = useConversationAIFlow()
  const appRouter = useAppRouter({ stackPush: push, browserDetect: true })
  const { t } = useTranslation()
  const isWebview = useIsWebview()

  const getFullUrl = useReturnFullUrl()

  return (
    <div className="flex w-screen flex-row items-center justify-center py-[12px] px-[20px]">
      <div className="absolute left-20">
        <QIcon_chevron_left
          width={'24px'}
          height={'24px'}
          color={COLORS.BLACK}
          onClick={() => {
            if (isWebview) {
              appRouter.replace(urls.webview.aiTutor.index(null, 4), {
                appScreenName: APP_SCREEN_NAME.AI_TUTOR_SCREEN,
                appSendData: {
                  url: getFullUrl(urls.webview.aiTutor.index(null, 4)),
                },
              })
            } else {
              // appRouter.back()
              // 안타깝게도, 이렇게 밖에 돌아갈 방법이 없음.
              // 만약에 모두 스택으로 쌓여 있었다면.. 좋았으련만?
              appRouter.push(urls.webview.aiTutor.index(null, 4), {
                appScreenName: APP_SCREEN_NAME.AI_TUTOR_SCREEN,
                appSendData: {
                  url: getFullUrl(urls.webview.aiTutor.index(null, 4)),
                },
              })
            }
          }}
        />
      </div>
      <div className="w-full flex flex-row items-center justify-center">
        <div className="flex h-full flex-row items-center justify-center gap-x-[20px] Body1-16Md">
          {t(n_ai_tutor.list.title)}
        </div>
      </div>
    </div>
  )
}

const ConversationListActivity: ActivityComponentType = () => {
  return (
    <WebviewStackContainer height="52px" title={<ConversationAIListTobNav />} border={false} isPullable={true}>
      <ConversationListBody />
    </WebviewStackContainer>
  )
}

export default ConversationListActivity
